import { render, staticRenderFns } from "./CustomBreadcrumb.vue?vue&type=template&id=af03090c&scoped=true"
import script from "./CustomBreadcrumb.vue?vue&type=script&lang=js"
export * from "./CustomBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./CustomBreadcrumb.vue?vue&type=style&index=0&id=af03090c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af03090c",
  null
  
)

export default component.exports